/* unplugin-vue-components disabled */import { render } from "./popupFavor.vue?vue&type=template&id=788179b1&scoped=true"
import script from "./popupFavor.vue?vue&type=script&lang=js"
export * from "./popupFavor.vue?vue&type=script&lang=js"

import "./popupFavor.vue?vue&type=style&index=0&id=788179b1&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788179b1"]])

export default __exports__